import { Item } from "./item";
export class TaskData {
    name;
    description;
    deadline;
    priority;
    notes;
    project;
    completed;
    constructor(name, description, deadline, priority, notes, project) {
        this.name = name;
        this.description = description;
        this.deadline = deadline;
        this.priority = priority;
        this.notes = notes;
        this.project = project;
        this.completed = false;
    }
}
export class Task extends Item {
    project;
    constructor(name, description, deadline, priority, notes, project) {
        super(name, description, deadline, priority, notes);
        this.project = project || null;
    }
    static sort(tasks) {
        const sorted = tasks.toSorted(Task.taskSortingFun);
        return sorted;
    }
    static fromFormData(data) {
        return new Task(data.get("name"), data.get("description"), new Date(data.get("deadline")), Number(data.get("priority")), data.get("notes"), data.get("project") || null);
    }
    static toJSON(tasks) {
        return JSON.stringify(tasks.map((t) => ({
            id: t.id,
            createdAt: t.createdAt,
            name: t.name,
            description: t.description,
            deadline: t.deadline,
            priority: t.priority,
            notes: t.notes,
            project: t.project,
            completed: t.completed,
        })));
    }
    static fromJSON(json) {
        const data = JSON.parse(json);
        return data.map((d) => {
            const { name, description, deadline, priority, notes, project } = d;
            const t = new Task(name, description, new Date(deadline), priority, notes, project);
            t.id = d.id;
            t.createdAt = new Date(d.createdAt);
            t.completed = d.completed;
            return t;
        });
    }
    static taskSortingFun(a, b) {
        if (a.deadline < b.deadline)
            return -1;
        if (a.deadline > b.deadline)
            return 1;
        if (a.priority > b.priority)
            return -1;
        return a.name.localeCompare(b.name);
    }
}
